import { useEffect, useState } from 'react';

import { useChatContext } from '../../../../context/ChatContext';

import type { EventHandler } from 'belo-js-sdk';

import type { StreamMessage } from '../../../../context/ChannelStateContext';

import type { DefaultBeloChatGenerics } from '../../../../types/types';

export const useGiphyPreview = <
  BeloChatGenerics extends DefaultBeloChatGenerics = DefaultBeloChatGenerics
>(
  separateGiphyPreview: boolean,
) => {
  const [giphyPreviewMessage, setGiphyPreviewMessage] = useState<StreamMessage<BeloChatGenerics>>();

  const { client } = useChatContext<BeloChatGenerics>('useGiphyPreview');

  useEffect(() => {
    const handleEvent: EventHandler<BeloChatGenerics> = (event) => {
      const { message, user } = event;

      if (message?.command === 'giphy' && user?.id === client.userID) {
        setGiphyPreviewMessage(undefined);
      }
    };

    if (separateGiphyPreview) client.on('message.new', handleEvent);
    return () => client.off('message.new', handleEvent);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [separateGiphyPreview]);

  return { giphyPreviewMessage, setGiphyPreviewMessage };
};
